const styles = theme => ({
  titlePaper: {
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  scrollableContainer: {
    marginRight: '16px',
  },
  listContainer: {
    maxHeight: '260px',
    overflow: 'auto',
  },
  pdfListItem: {
    backgroundColor: theme.palette.grey[100],
  },
  pdfFileName: {
    fontWeight: 500,
  },
  contentListItem: {
    fontSize: '14px',
  },
  listItemIcon: {
    minWidth: '40px',
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
})

export default styles
